function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListPolizaRenewal from "./ListPolizaRenewal";
import ModalPolizaRenewal from "./components/ModalPolizaRenewal";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch"; // No idea why visual studio says that this is wrong

import moment from "moment";
import "moment/locale/es";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";
import _ from "lodash";

var IndexPolizaRenewals = function IndexPolizaRenewals(props) {
  // remove cancelled and annulled polizas from the poliza renewals list
  var custom_post_filter_terms = {
    terms: {
      "poliza.aasm_state": ["draft", "waiting_activation", "active", "inactive"]
    }
  };

  var defaultQuery = function defaultQuery() {
    return {
      timeout: "10s",
      post_filter: {
        bool: {
          must: [custom_post_filter_terms]
        }
      }
    };
  };

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedPolizaRenewal = _React$useState2[0],
      setSelectedPolizaRenewal = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openModal = _React$useState4[0],
      setOpenModal = _React$useState4[1];

  var aYearAgo = moment().subtract(2, "years").toDate();
  var today = moment().toDate();

  var componentIds = function componentIds() {
    var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var filters = ['poliza_ramo', 'poliza_renewal_status_name', 'poliza_tipo_de_pago', 'poliza_company_name', 'poliza_nombre_contratante', 'poliza_nombre_asegurado', 'poliza_id', 'poliza_finish_date', 'created_at', 'updated_at'];
    return _.without(filters, except);
  };

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "PolizaRenewalsList" //highlight
      ,
      defaultQuery: defaultQuery,
      dataField: "updated_at",
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: "desc",
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, null, data.id, /*#__PURE__*/React.createElement(ListPolizaRenewal, {
          polizaRenewals: data,
          onSelectedPolizaRenewal: onSelectedPolizaRenewal
        }));
      }
    });
  };

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "poliza_id",
      dataField: ["poliza.id_keyword", "poliza.code"],
      queryFormat: "and",
      fuzziness: 1,
      title: "N\xBA propuesta o p\xF3liza",
      placeholder: "Buscar por n\xFAmero de propuesta o c\xF3digo de poliza",
      defaultQuery: defaultQuery,
      autosuggest: false // somehow it crashes with this
      ,
      react: {
        and: componentIds("poliza_id")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_ramo",
      dataField: "poliza.ramo.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Ramo",
      title: "Ramo",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_ramo")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_renewal_status_name",
      dataField: "status_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de la renovaci\xF3n",
      title: "Estado de la renovaci\xF3n",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_renewal_status_name")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_tipo_de_pago",
      dataField: "poliza.tipo_de_pago.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Forma de pago",
      title: "Forma de pago",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_tipo_de_pago")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_company_name",
      dataField: "poliza.company.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Compa\xF1\xEDa",
      title: "Compa\xF1\xEDa",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_company_name")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_contratante",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery //dataField="poliza.document_data.nombre_contratante.keyword"
      ,
      dataField: "poliza.contratante.full_name.keyword" //nestedField="poliza.document_data"
      ,
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre contratante",
      title: "Contratante",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_contratante")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_asegurado",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "poliza.asegurado.full_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre Asegurado",
      title: "Asegurado",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_asegurado")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      componentId: "poliza_finish_date",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "poliza.finish_date",
      title: "Fecha de fin vigencia",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      componentId: "created_at",
      defaultQuery: defaultQuery,
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "created_at",
      title: "Fecha de creaci\xF3n",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "updated_at",
      dataField: "updated_at",
      title: "Fecha de \xFAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  var onSelectedPolizaRenewal = function onSelectedPolizaRenewal(polizaRenewal) {
    setSelectedPolizaRenewal(polizaRenewal);
    setOpenModal(true);
  };

  return /*#__PURE__*/React.createElement("div", null, selectedPolizaRenewal && /*#__PURE__*/React.createElement(ModalPolizaRenewal, {
    polizaRenewal: selectedPolizaRenewal,
    open: openModal,
    onClose: function onClose() {
      setSelectedPolizaRenewal(null);
      setOpenModal(false);
    }
  }), /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "poliza_renewals",
    url: "".concat(process.env.SEGUROS_API_URL) //analytics={true}
    ,
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), renderList()));
};

export default IndexPolizaRenewals;